module.exports = __webpack_public_path__ + "img/profile.23bda5ca.png";